import { useQuery } from '@tanstack/react-query'
import { moduleOf, shellQuery } from '../api/shell'
import { Content } from '../ui/Shell'
import { ChangeProposalsPanel } from './ChangeProposalsPanel'

/**
 * `Changes::index` - pagina intreaga, la /app/change (adresa directa).
 *
 * Calea obisnuita e sertarul din dreapta (`ChangeDrawer`). Pagina include
 * ACELASI panou si aceleasi actiuni - deci merge la fel, doar in tot ecranul
 * in loc de sertar. `views/version-3/changes/index.php`.
 */
export function ChangeProposalsPage() {
  useQuery(shellQuery(moduleOf('/change')))

  return (
    <Content>
      <div className="row">
        <div className="col-md-12">
          <h3 style={{ margin: '4px 0 12px' }}>
            <i className="fas fa-robot" aria-hidden="true"></i> Change Proposals{' '}
            <small className="text-muted">What the AI proposes to run - and who approved it</small>
          </h3>
        </div>
      </div>
      <ChangeProposalsPanel />
    </Content>
  )
}
